export const styles = {
  contentSaveButton: {
    margin: '1rem 1rem 1rem 1rem',
  },
};
